import axios from 'axios';
import { debug } from '@/utils/debug';
import { SECURE_URL, searchObj } from '@/utils/constants';
import { mergeUrl, getQueryParams } from '@/utils/utils';
import { requestToNative } from '../service/jsbridge';

let requestURL: string;

function get(url: string, params = {}): Promise<any> {
  requestURL = url;
  params = Object.assign(getQueryParams(window.captchaOptions), params);
  debug(url, 'GET request args：', params);
  if (searchObj.use_jsb_request === '1') {
    return requestToNative('get', url, params);
  } else {
    return axios.get(url, { params }) as any;
  }
}

function post(
  url: string,
  data = {},
  config: Record<string, any> = { params: {} }
): Promise<any> {
  requestURL = url;
  config.params = Object.assign(
    getQueryParams(window.captchaOptions),
    config.params
  );
  debug(url, 'POST request args：', 'data:', data, 'config:', config);
  if (searchObj.use_jsb_request === '1') {
    return requestToNative('post', url, config.params, data);
  } else {
    return axios.post(url, data, config) as any;
  }
}
// axios.defaults.timeout = 5000;

axios.interceptors.response.use(
  (response) => {
    const res = response.data;
    let logId = response.headers['x-tt-logid'];
    if (response.config.url === 'captcha/get') {
      window.logIdMap.get_log_id = logId;
    } else if (response.config.url === 'captcha/verify') {
      window.logIdMap.verify_log_id = logId;
    }

    if (res.code === 200 || res.code === '10000') {
      debug('success return args：', res);
      return res;
    }
    debug(requestURL, 'request failed：', res);
    return Promise.reject(res);
  },
  (error) => {
    debug(requestURL, 'server error：', error);
    return Promise.reject(error);
  }
);

export { get, post };
